const keys = require('lodash/keys');

const typeToTemplateMap = {
  input: require('./quantity-input.html'),
  select: require('./quantity-select.html')
};

class QuantityControlProvider {
  static get $inject() {
    return ['$injector', 'qtyType', 'quantities', 'qtyInputConfig'];
  }

  constructor($injector, qtyType, quantities, qtyInputConfig) {
    if ($injector.has('quantityControlConfig')) {
      Object.assign(this, $injector.get('quantityControlConfig'));
    }
    else {
      this.type = qtyType;
      this.quantities = quantities;
      this.min = qtyInputConfig.min;
      this.max = qtyInputConfig.max;
      this.showInputButtons = qtyInputConfig.buttons;
    }

    this.templateUrl = typeToTemplateMap[this.type];
  }

  setType(type) {
    this.templateUrl = typeToTemplateMap[type];
    if (!this.templateUrl) {
      throw new Error(`${type} is not recognized. Please use one of: ${keys(typeToTemplateMap)}`);
    }
  }

  $get() {
    return { ...this };
  }
}

module.exports = QuantityControlProvider;
